import { BillingDetails } from './../../data/web-api-client';
import '@/types';
import notificationService from '@/services/notificationService';
// import companiesRepository from '@/services/companiesRepository';
import contactsRepository from '@/services/contactsRepository';

export default class Company implements ICompany {
    public pricingAgreements: IPricingAgreement[] | null = [];
    public id?: string;
    public logs: ILog[] = [];
    public companyName: string = '';
    public vatNumber?: string = '';
    public lastname?: string;
    public email?: string;
    public phone?: string;
    public language?: string;
    public termsOfPayment: number | null = null;
    public contactIds: string[] = [];
    public tags: string[] = [];
    public notes?: string;
    public readonly displayName: string = '';
    public addresses: IAddress[] = [];
    public type: string = 'Company';
    public billingDetails?: BillingDetails;

    public loading: boolean = false;
    public saving: boolean = false;

    public async loadData(id: string) {
        try {
            this.loading = true;
            const result = await contactsRepository.getSingle(id);
            Object.assign(this, result.data);
        } catch {
            notificationService.failedToLoad();
        } finally {
            this.loading = false;
        }
    }

    public async save() {
        let saved = false;
        try {
            this.saving = true;
            if (this.id) {
                const result = await contactsRepository.update(this);
                Object.assign(this, result.data);
            } else {
                const result = await contactsRepository.create(this);
                Object.assign(this, result.data);
            }
            saved = true;
            notificationService.saved();
        } catch {
            notificationService.failedToLoad();
        } finally {
            this.saving = false;
        }

        return saved;
    }

    public async addOrUpdateAddress(address: IAddress, index: number = -1) {
        try {
            if (index === -1) {
                this.addresses.push(address);
            } else {
                this.addresses[index] = address;
            }
            await this.save();
            return true;
        } catch {
            notificationService.failedToSave();
            return false;
        }
    }

    public async deleteAddress(index: number) {
        this.addresses.splice(index, 1);
        await this.save();
    }
}
